import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow } from "vue";
const _hoisted_1 = {
  style: {
    "background-color": "white",
    "border-bottom": "1px solid #eee"
  }
};
const _hoisted_2 = {
  style: {
    "padding": "15px 22px",
    "max-width": "1600px",
    "margin": "0px auto",
    "display": "flex",
    "align-items": "flex-start"
  }
};
const _hoisted_3 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "min-height": "24px",
    "flex-shrink": "0"
  }
};
const _hoisted_4 = ["href"];
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  style: {
    "flex": "1",
    "min-width": "0",
    "padding": "0 12px",
    "text-align": "center",
    "line-height": "1.35",
    "display": "-webkit-box",
    "line-clamp": "2",
    "-webkit-line-clamp": "2",
    "-webkit-box-orient": "vertical",
    "overflow": "hidden",
    "word-break": "break-word"
  }
};
const _hoisted_7 = {
  style: {
    "flex-shrink": "0"
  }
};
const _hoisted_8 = ["value"];
const _hoisted_9 = {
  id: "content"
};
const _hoisted_10 = {
  key: 0,
  style: {
    "height": "30vh",
    "line-height": "30vh"
  }
};
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  key: 2
};
const _hoisted_13 = {
  key: 3
};
const _hoisted_14 = {
  key: 0
};
const _hoisted_15 = {
  key: 1
};
const _hoisted_16 = {
  class: "verifycode"
};
const _hoisted_17 = {
  key: 2,
  style: {
    "cursor": "pointer"
  }
};
const _hoisted_18 = {
  style: {
    "padding": "0px 22px",
    "text-align": "left",
    "font-size": "12px"
  }
};
const _hoisted_19 = {
  style: {
    "margin-left": "10px",
    "margin-right": "10px"
  }
};
const _hoisted_20 = {
  style: {
    "cursor": "pointer",
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center",
    "padding": "0px 22px",
    "text-align": "left",
    "font-size": "18px",
    "margin-bottom": "10px"
  }
};
const _hoisted_21 = {
  style: {
    "color": "#0099fff0",
    "font-size": "14px"
  }
};
const _hoisted_22 = ["onClick"];
const _hoisted_23 = {
  key: 0,
  style: {
    "margin-bottom": "5px"
  }
};
const _hoisted_24 = {
  style: {
    "text-align": "left",
    "margin": "20px",
    "margin-bottom": "120px",
    "margin-top": "0px",
    "border-radius": "10px"
  }
};
const _hoisted_25 = {
  key: 0,
  style: {
    "height": "30vh",
    "line-height": "30vh"
  }
};
const _hoisted_26 = ["onClick"];
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon-file",
  style: {
    "font-size": "24px",
    "color": "#0099fff0",
    "align-self": "center"
  }
}, null, -1);
const _hoisted_28 = ["onClick"];
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon-folder2",
  style: {
    "font-size": "24px",
    "color": "#0099fff0",
    "align-self": "center"
  }
}, null, -1);
const _hoisted_30 = [_hoisted_29];
const _hoisted_31 = ["onClick"];
const _hoisted_32 = {
  class: "van-multi-ellipsis--l3 file-title",
  style: {
    "font-size": "14px"
  }
};
const _hoisted_33 = {
  style: {
    "font-size": "12px",
    "color": "#00000060"
  }
};
const _hoisted_34 = {
  style: {
    "width": "40px",
    "min-width": "14px",
    "display": "flex",
    "margin-left": "10px"
  }
};
const _hoisted_35 = {
  key: 0,
  style: {
    "position": "fixed",
    "bottom": "40px",
    "left": "0px",
    "right": "0px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");
  const _component_van_loading = _resolveComponent("van-loading");
  const _component_van_empty = _resolveComponent("van-empty");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_image = _resolveComponent("van-image");
  const _component_van_checkbox = _resolveComponent("van-checkbox");
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_router_view), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [$data.loadingNodeInfo ? (_openBlock(), _createBlock(_component_van_loading, {
    key: 0,
    color: "#0094ff",
    style: {
      "width": "24px",
      "margin-right": "10px"
    }
  })) : _createCommentVNode("", true), !$data.loadingNodeInfo && !$data.loadingNodeInfoFailed ? (_openBlock(), _createElementBlock("a", {
    key: 1,
    href: $data.homepage,
    target: "_blank",
    style: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_createElementVNode("img", {
    style: {
      "height": "24px"
    },
    src: `${$data.baseURL}/syy/assets/mainboard/logo`,
    alt: ""
  }, null, 8, _hoisted_5)], 8, _hoisted_4)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, _toDisplayString($options.displayBrandName) + " " + _toDisplayString(_ctx.$t("brand.fileShare")), 1), _createElementVNode("div", _hoisted_7, [_withDirectives(_createElementVNode("select", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.currentLocale = $event),
    onChange: _cache[1] || (_cache[1] = (...args) => $options.changeLocale && $options.changeLocale(...args)),
    style: {
      "border": "1px solid #ddd",
      "padding": "2px 5px",
      "border-radius": "3px",
      "font-size": "12px",
      "background-color": "white"
    }
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.supportedLanguages, lang => {
    return _openBlock(), _createElementBlock("option", {
      key: lang.code,
      value: lang.code
    }, _toDisplayString(lang.name), 9, _hoisted_8);
  }), 128))], 544), [[_vModelSelect, $data.currentLocale]])])])]), _createElementVNode("div", _hoisted_9, [$data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_van_loading, {
    color: "#0094ff"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("common.loading")), 1)]),
    _: 1
  })])) : _createCommentVNode("", true), $data.outdate ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_van_empty, {
    image: "error",
    description: _ctx.$t('share.expired')
  }, null, 8, ["description"])])) : _createCommentVNode("", true), $data.loadingNodeInfoFailed ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_van_empty, {
    image: "error",
    description: _ctx.$t($data.loadingNodeInfoMsgKey)
  }, null, 8, ["description"])])) : _createCommentVNode("", true), !$data.loadingNodeInfo && !$data.loading && !$data.outdate ? (_openBlock(), _createElementBlock("div", _hoisted_13, [$data.invalidUrl ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(_component_van_empty, {
    image: "error",
    description: _ctx.$t('share.invalidLink')
  }, null, 8, ["description"])])) : _createCommentVNode("", true), !$data.invalidUrl && $data.needVerifyCode && !$data.loadingNodeInfoFailed ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createVNode(_component_van_field, {
    modelValue: $data.verifyCode,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.verifyCode = $event),
    center: "",
    "label-width": "50px",
    clearable: "",
    label: _ctx.$t('share.verifyCodeLabel'),
    placeholder: _ctx.$t('share.verifyCodePlaceholder')
  }, {
    button: _withCtx(() => [_createVNode(_component_van_button, {
      size: "small",
      type: "primary",
      onClick: $options.verify
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("share.extractFiles")), 1)]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  }, 8, ["modelValue", "label", "placeholder"])])])) : _createCommentVNode("", true), !$data.invalidUrl && !$data.needVerifyCode && !$data.loadingNodeInfoFailed ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("p", _hoisted_18, [_createTextVNode(_toDisplayString(_ctx.$t("common.createTime")) + ": " + _toDisplayString($options.dtformat($data.shareInfo.createTime)) + " ", 1), _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("common.expireTime")) + ": " + _toDisplayString($options.dtformat($data.shareInfo.expireAt)), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.totalSize")) + ": " + _toDisplayString($options.filesize($data.totalSize)), 1)]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.dirs, item => {
    return _openBlock(), _createElementBlock("span", {
      key: item.path,
      onClick: $event => $options.clickpush(item.path)
    }, _toDisplayString($options.getSafeTextOverflow(item.name, 15, 15)), 9, _hoisted_22);
  }), 128))]), $options.isBigScreen ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_withDirectives(_createVNode(_component_van_button, {
    size: "small",
    type: "primary",
    style: {
      "width": "80px"
    },
    onClick: $options.downloadAll
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("common.downloadAll")), 1)]),
    _: 1
  }, 8, ["onClick"]), [[_vShow, $data.dir === '/']]), _withDirectives(_createVNode(_component_van_button, {
    size: "small",
    type: "primary",
    style: {
      "margin-left": "10px",
      "width": "80px"
    },
    onClick: $options.download
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("common.downloadSelected")), 1)]),
    _: 1
  }, 8, ["onClick"]), [[_vShow, $data.checked.length > 0]]), _withDirectives(_createVNode(_component_van_button, {
    size: "small",
    plain: "",
    type: "primary",
    style: {
      "margin-left": "10px",
      "width": "80px"
    },
    onClick: $options.toggleSelected
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.checked.length > 0 ? _ctx.$t("common.deselectAll") : _ctx.$t("common.selectAll")), 1)]),
    _: 1
  }, 8, ["onClick"]), [[_vShow, $data.dir !== '/']])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_24, [$data.filelist.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createVNode(_component_van_empty, {
    color: "#0094ff",
    description: _ctx.$t('common.noFiles')
  }, null, 8, ["description"])])) : _createCommentVNode("", true), _createVNode(_component_van_checkbox_group, {
    modelValue: $data.checked,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.checked = $event)
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.filelist, item => {
      return _openBlock(), _createElementBlock("div", {
        key: item.ufi,
        class: "filelist"
      }, [!item.fileInfo.isDir ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "leading",
        style: {
          "background-color": "#0099ff20"
        },
        onClick: () => $options.clickItem(item)
      }, [_createVNode(_component_van_image, {
        width: "40",
        height: "40",
        fit: "cover",
        src: $options.getSingleFileThumbnailUrl($data.shareCode, $data.verifyCode, item.ufi)
      }, {
        error: _withCtx(() => [_hoisted_27]),
        _: 2
      }, 1032, ["src"])], 8, _hoisted_26)) : _createCommentVNode("", true), item.fileInfo.isDir ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "leading",
        style: {
          "background-color": "#0099ff20"
        },
        onClick: () => $options.clickItem(item.fileInfo)
      }, _hoisted_30, 8, _hoisted_28)) : _createCommentVNode("", true), _createElementVNode("div", {
        style: {
          "flex": "1"
        },
        class: "van-multi-ellipsis--l3",
        onClick: () => $options.clickItem(item.fileInfo)
      }, [_createElementVNode("div", _hoisted_32, _toDisplayString(item.fileInfo.name), 1), _createElementVNode("div", _hoisted_33, _toDisplayString($options.filesize(item.fileInfo.size)), 1)], 8, _hoisted_31), _createElementVNode("div", _hoisted_34, [_createVNode(_component_van_checkbox, {
        "icon-size": "14px",
        name: item.ufi,
        style: {
          "padding-left": "13px",
          "padding-right": "13px"
        }
      }, null, 8, ["name"])])]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue"])]), !$options.isBigScreen && $data.filelist.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_35, [_withDirectives(_createVNode(_component_van_button, {
    size: "small",
    type: "primary",
    style: {
      "width": "80px"
    },
    onClick: $options.downloadAll
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("common.downloadAll")), 1)]),
    _: 1
  }, 8, ["onClick"]), [[_vShow, $data.dir === '/']]), _createVNode(_component_van_button, {
    size: "small",
    type: "primary",
    style: {
      "margin-left": "10px",
      "width": "80px"
    },
    onClick: $options.download
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("common.downloadSelected")), 1)]),
    _: 1
  }, 8, ["onClick"]), _withDirectives(_createVNode(_component_van_button, {
    size: "small",
    type: "primary",
    style: {
      "margin-left": "10px",
      "width": "80px"
    },
    onClick: $options.toggleSelected
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.checked.length > 0 ? _ctx.$t("common.deselectAll") : _ctx.$t("common.selectAll")), 1)]),
    _: 1
  }, 8, ["onClick"]), [[_vShow, $data.dir !== '/']])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])], 64);
}